module.exports = __webpack_public_path__ + "static/media/ifca_globe.8d9435e1.svg";